import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCall = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		id: "Vector",
		d: "M17.6172 14.6094C16.9969 13.9844 15.4945 13.0723 14.7656 12.7047C13.8164 12.2266 13.7383 12.1875 12.9922 12.7418C12.4945 13.1118 12.1637 13.4422 11.5812 13.318C10.9988 13.1938 9.7332 12.4934 8.625 11.3887C7.5168 10.284 6.77578 8.98167 6.65117 8.4012C6.52656 7.82073 6.8625 7.49378 7.22891 6.99495C7.74531 6.29183 7.70625 6.17464 7.26484 5.22542C6.9207 4.48714 5.98203 2.99886 5.35469 2.38167C4.68359 1.71878 4.68359 1.83597 4.25117 2.01566C3.89912 2.16375 3.56137 2.3438 3.24219 2.55355C2.61719 2.96878 2.27031 3.3137 2.02773 3.83206C1.78516 4.35042 1.67617 5.56566 2.92891 7.84144C4.18164 10.1172 5.06055 11.2809 6.87969 13.095C8.69883 14.909 10.0977 15.8844 12.1426 17.0313C14.6723 18.4481 15.6426 18.1719 16.1625 17.9297C16.6824 17.6875 17.0289 17.3438 17.4449 16.7188C17.6552 16.4001 17.8357 16.0628 17.984 15.711C18.1641 15.2801 18.2812 15.2801 17.6172 14.6094Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeMiterlimit: 10
	})
});
export default SvgCall;
